<template>
    <div>
      <div class="app-content content devcontent">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
          <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
            <div class="container-fluid">
              <div class="row breadcrumbs-top">
                <div class="col-md-12 content-header-left px-0">
                  <h3 class="content-header-title float-left mb-0">
                    Breakdown Management
                  </h3>
                  <div class="breadcrumb-wrapper">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">
                        <router-link to="#"> Dashboard</router-link>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-body">
            <section>
              <div class="card">
                <div class="card-header px-0 common_top_title_searchbgst_dock">
                  <div class="container-fluid">
                    <div class="row row fc_my-05">
                      <div class="w-auto px-1 mobile-padding-0-2">
                        <div
                          class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                        >
                          <div class="avatar-content">
                            <i
                              class="i_icon_st la-people-carry las lab font-medium-5"
                            ></i>
                          </div>
                        </div>
                        <h4 class="card-title d-inline-flex ml-0 mb-0">
                          Breakdown Details
                        </h4>
                      </div>
                      <div class="col-12 col-sm">
                        <div class="d-flex justify-content-end mt-2 mt-sm-0">
                          <button class="btn btn-primary" @click="onCreateFormHandler">Create</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
  
                <div class="col-lg-12 px-0">
                  <div class="card text-center mb-1">
                    <div
                      class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
                    >
                      <div
                        class="nav-tabs epg-tabs subcategory-tabs no-bg scroll-both"
                      >
                        <nav class="nav-tabs-wrapper main_divtabsview">
                          <ul
                            class="tabs_masters_detailstabing_pills nav nav-pills nav-pill-primary pb-0 nav-tabs-items dragscroll"
                          >
                            <li
                              class="nav-item tabs-item active main_divtabsviewtoggle"
                              data-day="1"
                            ></li>
                          </ul>
                        </nav>
                      </div>
  
                      <div class="tab-content">
                        <div
                          role="tabpanel"
                          class="tab-pane active"
                          id="breakdown_form"
                        >

                          <div>
                            <div class="table-responsive datatableview">
                              <table
                                class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"
                              >
                                <thead>
                                  <tr>
                                    <!-- <th class="text-left align-middle">Warehouse id</th> -->
                                    <th class="text-left align-middle">
                                      Vehicle
                                    </th>
                                    <!-- <th class="text-left align-middle">
                                        Driver Photo
                                      </th> -->
                                    <th class="text-left align-middle">
                                      Driver Name
                                    </th>
                                    <th class="text-left align-middle">
                                      Mobile
                                    </th>
                                    <th class="text-left align-middle">
                                      Landmark
                                    </th>
                                    <th class="text-left align-middle">
                                      Comment/Reason
                                    </th>
                                    <!-- <th class="text-center align-middle">
                                        Upload Photos
                                      </th> -->
                                      <th class="text-left align-middle">
                                      Action
                                    </th>
                                    <!-- <th class="text-center align-middle">
                                      Photos
                                    </th> -->
                                    <!-- <th class="text-center align-middle">
                                        FIR Copy
                                      </th> -->
                                  </tr>
                                </thead>
                                <vue-element-loading
                                spinner="bar-fade-scale"
                                :active="isMasterListLoading"
                                />
                                <tbody>
                                  <template
                                    v-for="(data, index) of breakdown_form.list"
                                  >
                                    <tr>
                                      <td data-column="Vehicle" class="text-left">
                                        {{ data.vehicle_id }}
                                      </td>
                                      <td
                                        data-column="Driver Name"
                                        class="text-left"
                                      >
                                        {{ data.driver_name }}
                                      </td>
                                      <td data-column="Mobile" class="text-left">
                                        {{ data.mobile }}
                                      </td>
                                      <td
                                        data-column="Landmark"
                                        class="text-left"
                                      >
                                        {{ data.landmark }}
                                      </td>
                                      <td
                                        data-column="Comment/Reason"
                                        class="text-left"
                                      >
                                        {{ data.comment }}
                                      </td>
                                      <td 
                                        data-column="Action"
                                        class="text-left">
                                        <span> 
                                           <i class="las la-edit"></i>
                                           <a v-on:click="getId(data.breakdown_id)" href="javascript:void(0);">Edit</a>
                                        </span>
                                      </td>
                                      <!-- <td
                                        data-column="Photo details"
                                        class="text-left merge_column_detals photo_details_doc_borders"
                                      >
                                        <div
                                          class="daily_transaction_photos_details"
                                        >
                                          <ul>
                                            <li>
                                              <div class="photo_details_doc_04">
                                                <div
                                                  class="innerphoto_details_doc_04"
                                                >
                                                  <img
                                                    alt="photo"
                                                    class=""
                                                    :src="
                                                      findImageUrl(
                                                        'breakdown_form',
                                                        data.driver_photo
                                                      )
                                                    "
                                                    @click="
                                                      getPhotoLink(
                                                        data.driver_photo
                                                      )
                                                    "
                                                  />
                                                </div>
                                                <h6 class="vehicle_name_text">
                                                  Driver Photo
                                                </h6>
                                              </div>
                                            </li>
                                            <li>
                                              <div class="photo_details_doc_04">
                                                <div
                                                  class="innerphoto_details_doc_04"
                                                >
                                                  <img
                                                    alt="photo"
                                                    class=""
                                                    :src="
                                                      findImageUrl(
                                                        'breakdown_form',
                                                        data.breakdown_photo
                                                      )
                                                    "
                                                    @click="
                                                      getPhotoLink(
                                                        data.breakdown_photo
                                                      )
                                                    "
                                                  />
                                                </div>
                                                <h6 class="vehicle_name_text">
                                                  Uploaded Photo
                                                </h6>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                      </td> -->
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </div>
                            <div
                              class="pageCenter text-center mt-4 pagination_viewallpages"
                            >
                              <pagination
                                v-model="breakdown_form.page"
                                :records="breakdown_form.totalcount"
                                :per-page="breakdown_form.pagelimit"
                                @paginate="
                                  (e) => handlePageChange(e, 'breakdown_form')
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import moment from "moment";
  import Pagination from "vue-pagination-2";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  import Treeselect from "@riophae/vue-treeselect";
  import VueElementLoading from "vue-element-loading";
  
  import "video.js/dist/video-js.min.css";
  import videojs from "video.js";
  import RecordRTC from "recordrtc";
  import "videojs-record/dist/css/videojs.record.css";
  import Record from "videojs-record/dist/videojs.record.js";
  import FFmpegjsEngine from "videojs-record/dist/plugins/videojs.record.ffmpegjs.js";
  
  import {
    XCircleIcon,
    FileIcon,
    UploadIcon,
    DownloadIcon,
    EditIcon,
  } from "vue-feather-icons";
  import CONSTANT from "../../constants.js";
  import common_methods from "../../utils/common_methods";
  import searchMasterNameList from "../../utils/searchMasterNameList";
  
  export default {
    name: "breakdownDetails",
    mixins: [common_methods, searchMasterNameList],
    components: {
      Treeselect,
      DatePicker,
      VueElementLoading,
      Pagination,
      UploadIcon,
      FileIcon,
      XCircleIcon,
      DownloadIcon,
      EditIcon,
      Pagination,
    },
    data() {
      return {
        isMasterListLoading: true,
        breakdown_form: false,
        cropAllowed: ["breakdown_photo"],
        fileTitle: ["breakdown_photo"],
        breakdown_form: {
          url: "/breakdowns",
          list: [],
          totalcount: 0,
          pageCount: 0,
          page: 1,
          pagelimit: CONSTANT.LIMIT,
          currPageNum: 0,
          pageoffset: 1,
          presignedUrls: [],
        },
        captures: {
          driver_photo: {
            stream: null,
            file: null,
            img: null,
            isCropped: false,
            showCropper: false,
          },
          breakdown_photo: {
            stream: null,
            file: null,
            img: null,
            isCropped: false,
            showCropper: false,
          },
          FIR_copy_photo: {
            stream: null,
            file: null,
            img: null,
            isCropped: false,
            showCropper: false,
          },
        },
        photoCaptureSound: "sound/iphone-camera-capture-6448.wav",
      };
    },
    created() {
     // this.getCameraSelection();
     // this.getVehicleList();
      this.getMasterList();
    },
    mounted() {
    },
    methods: {
      getId(id){
        let routeData = this.$router.resolve({ 
        path: `/editbreakdown/${id}`,
      })
      window.open(routeData.href);
      },

      onCreateFormHandler() {
      this.$router.push('/breakdown-management')
    },
     findImageUrl(tab, key) {
        let presignedUrls = this[tab].presignedUrls;
        let urlObj = presignedUrls.find((obj) => obj.fileKey === key);
        if (urlObj) return urlObj.url;
        return "";
      },
      getPhotoLink(key) {
        this.getPresignUrl(key)
          .then((result) => {
            this.photo_links = [result];
            // $('.imagepreview').attr('src', this.photo_link);
            // $("#imagemodal").modal("show");
          })
          .catch((e) => {
            this.displayError(e);
            this.photo_links = [];
          });
      },
      getMasterList(tab = "breakdown_form") {
        this.isMasterListLoading = true;
        let url = this[tab].url;
        let method = "POST";
        let payload = {
          page: this[tab].page,
          rows: this[tab].pagelimit,
        };
        this.makeRequest(method, url, payload)
          .then((result) => {
            this.isMasterListLoading = false;
            this[tab].list = result.data.data.rows;
            this[tab].totalcount = result.data.data.count;
            this[tab].pageCount = Math.ceil(
              result.data.data.count / this[tab].pagelimit
            );
            this[tab].presignedUrls = result.data.data.presignedUrls;
          })
          .catch((e) => {
            this.isMasterListLoading = false;
            this.displayError(e);
          });
      },
      handlePageChange(pageNum, tab) {
        this[tab].pageoffset = pageNum;
        this[tab].currPageNum = pageNum - 1;
  
        this.getMasterList(tab);
        setTimeout(() => {
          $("html, body").animate({
            scrollTop: $(`#${tab}`).offset().top - 70,
          });
        }, 500);
      },
      defaultSize({ imageSize, visibleArea }) {
        let width = (visibleArea || imageSize).width;
        let height = (visibleArea || imageSize).height;
        let isCropped = this.captures.driver_photo.isCropped;
        if (!isCropped) {
          return {
            width: width,
            height: height,
          };
        }
        return {
          width,
          height,
        };
      },
      breakdownDefaultSize({ imageSize, visibleArea }) {
        let width = (visibleArea || imageSize).width;
        let height = (visibleArea || imageSize).height;
        let isCropped = this.captures.breakdown_photo.isCropped;
        if (!isCropped) {
          return {
            width: width,
            height: height,
          };
        }
        return {
          width,
          height,
        };
      },
      //   FIRCopyDefaultSize({ imageSize, visibleArea }) {
      //     let width = (visibleArea || imageSize).width;
      //     let height = (visibleArea || imageSize).height;
      //     let isCropped = this.captures.FIR_copy_photo.isCropped;
      //     if (!isCropped) {
      //       return {
      //         width: width,
      //         height: height,
      //       };
      //     }
      //     return {
      //       width,
      //       height,
      //     };
      //   },
    },
  };
  </script>
  <style scoped>
  .alignment {
    margin-left: 20px;
    margin-bottom: 20px;
  }
  .requiredField {
    margin-left: 2px;
    color: red;
  }
  #overlay-camera {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 1);
    z-index: 2;
    cursor: pointer;
  }
  
  .overlay-camera {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 1);
    z-index: 2;
    cursor: pointer;
  }
  </style>
  